<script setup lang="ts">
import { AppIcon, BrandMark } from '@atum-remote/ui';
defineProps<{ error?: unknown; failed?: boolean }>();
const reload = () => window.location.reload();
</script>

<template>
  <main class="session-load">
    <div class="session-load-panel panel">
      <BrandMark />
      <template v-if="failed || error">
        <h1 role="alert">AI work could not load.</h1>
        <p>The page may have changed since you opened it, or the connection was interrupted.</p>
        <button type="button" class="primary" @click="reload">Reload AI work</button>
      </template>
      <p v-else role="status">Loading AI work…</p>
      <a href="/" aria-label="Back to devices"><AppIcon name="back" />Back to devices</a>
    </div>
  </main>
</template>
